
<div mat-dialog-title>Models Ready to Import<button class="close" mat-button title="Cancel" (click)="close()"><i class="material-icons clear" >clear</i></button></div>
<mat-dialog-content>
  <div>{{data.modelsToAdd?.length}} models of {{data.validatedModels?.length}} in your file will be added to or overwritten in iRebal.
  </div>
  <div>
    @if (!isUiTest) {
      <irb-inventory-grid
        [style.width] = "'100%'"
        [style.height] = "'240px'"
        [showSideBar] = "false"
        [gridOptions] = "gridOptions"
        [frameworkComponents] = {}
        [rowData] = "data.validatedModels"
      (gridReady) = "onGridReady($event)"></irb-inventory-grid>
    }
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button id="closeButton" (click)="close()" class="btn-medium-secondary">Cancel entire import</button>
  <button id="continueButton" (click)="completeImport()" [disabled]="!(data.modelsToAdd?.length > 0)" class="btn-medium-primary">Finish</button>
</mat-dialog-actions>
